

<div class="contact-container body-content-area hidden-element" #fixedcontainer  *ngIf="tableData&&tableData?.RateTableName && tableType=='fixed'" >
  @if(fileType === 'excel'){
    <table >
      <tr></tr><tr></tr>
        <tr class="header-area">
           <td></td><td></td><td></td> <td colspan="2" class="sub-title" style="left: 0px;text-transform: uppercase;">{{tableData?tableData?.RateTableName:'Table Name'}}</td>
        </tr>
        <tr><td colspan="5"></td><td>CONFIDENTIAL</td></tr>
        <tr></tr>
        <tr>
          <td colspan="2">Origin Region: {{this.tableService.onBPRegion(tableData,'BidPackOriginCountry') }}</td>
          <td></td><td></td><td></td> 
          <td colspan="2">Excluding VAT: {{tableData.ExcludingVAT?'Yes':'No'}}</td> 
        </tr>
        
        <tr>
          <td colspan="2">Origin Post Code (Area): {{this.tableService.onBPRegion(tableData,'BidPackOriginZipCodeArea')}}</td> 
          <td></td><td></td><td></td> 
          <td colspan="2">Country: {{findCountryName(tableData.CountryForFuelPriceID)}}</td>
        </tr>

        <tr>
          <td colspan="2">Destination: {{tableData.BidPackDestinationName}}</td> 
          
          <td></td><td></td><td></td> 
          <td colspan="2">Fuel Escalator comment: {{appService.deResingDoubleQuotess(tableData.FuelEscalatorComment)}}</td>
        </tr>
 
        <tr>
          <td colspan="2">Fuel Escalator Flag: {{tableData.FuelEscalatorFlag? 'Yes':'No'}}</td> 
          <td></td><td></td><td></td> 
          <td colspan="2">Fuel Trigger: 
            @if(tableData.FuelEscalatorFlag){
              {{ tableData.FuelTrigger }}%
            }
          </td>
        </tr>

        <tr>
          <td colspan="2">Rate Table Fuel Escalator Version: {{appService.deResingDoubleQuotess(tableData.FuelEscalatorVersion)}}</td> 
          <td></td><td></td><td></td> 
          <td colspan="2">Effective Date: {{effectiveDate |date:'dd/MM/yyyy'}}</td>
        </tr>

        <tr><td colspan="2">Fuel index price for future negotations (€/liter): {{tableData.FuelEscalatorFlag?tableData.FuelCostBaseline:''}}</td> </tr>
        <tr><td colspan="2">Data Source and country for fuel price: {{appService.deResingDoubleQuotess(tableData.DataSourceForFuelPrice)}}</td> </tr>
        <tr><td colspan="2">Fuel cost breakdown of carrier's total cost: 
        @if(tableData.FuelEscalatorFlag){
          {{ tableData.FuelCostBreakdown }}%
        }
        </td> </tr>  
        <tr></tr>
    </table>
  }
  @else{
    <div class="page-break" style="page-break-after: always;"></div>  
    <table style="width: 100%;">
        <tr class="header-area">
            <div class="sub-title new-font-header" style="left: 0px;text-transform: uppercase;height: 40px;">{{tableData?tableData?.RateTableName:'Table Name'}}</div>
        </tr>
        <hr>
        <div>
          <div class="new-font-size" style="justify-content: end;color: red;display: flex;font-weight: 600;margin: 10px;">CONFIDENTIAL</div>
      </div>
        <tr class="portion-container">
                <div class="portion-one">
                  <div class="items">
                    <span class="key new-font-size">Origin Region:</span>
                    <span class="value new-font-size"> {{this.tableService.onBPRegion(tableData,'BidPackOriginCountry') }}</span>
                </div>     
                <div class="items">
                    <span class="key new-font-size">Origin Post Code (Area):</span>
                    <span class="value new-font-size"> {{this.tableService.onBPRegion(tableData,'BidPackOriginZipCodeArea')}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Destination:</span>
                    <span class="value new-font-size"> {{tableData.BidPackDestinationName}}</span>
                </div>
                <div class="items">
                  <span class="key new-font-size">Fuel Escalator Flag:</span>
                  <span class="value new-font-size"> {{tableData.FuelEscalatorFlag? 'Yes':'No'}}</span>
                </div>
                <div class="items">
                  <span class="key new-font-size">Rate Table Fuel Escalator Version:</span>
                  <span class="value new-font-size"> {{appService.deResingDoubleQuotess(tableData.FuelEscalatorVersion)}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Fuel index price for future negotations (€/liter):</span>
                    @if(tableData.FuelEscalatorFlag){
                      <span class="value new-font-size"> {{tableData.FuelCostBaseline}}</span>
                      }
                </div>     
                <div class="items">
                    <span class="key new-font-size">Data Source and country for fuel price:</span>
                    <span class="value new-font-size"> {{appService.deResingDoubleQuotess(tableData.DataSourceForFuelPrice)}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Fuel cost breakdown of carrier's total cost:</span>
                    @if(tableData.FuelEscalatorFlag){
                      <span class="value new-font-size"> {{tableData.FuelCostBreakdown}}%</span>
                      }
                </div>
            </div>

            <div class="portion-two">
                <div class="items">
                    <span class="key new-font-size">Excluding VAT: </span>
                    <span class="value new-font-size"> {{tableData.ExcludingVAT?'Yes':'No'}}</span>
                </div>
                <div class="items">
                    <span class="key new-font-size">Country: </span>
                    <span class="value new-font-size"> {{findCountryName(tableData.CountryForFuelPriceID)}}</span>
                </div>
                <div class="items">
                  <span class="key new-font-size">Fuel Escalator comment: </span>
                  <span class="value new-font-size"> {{appService.deResingDoubleQuotess(tableData.FuelEscalatorComment)}}</span>
              </div>
                <div class="items">
                    <span class="key new-font-size">Fuel Trigger: </span>
                    @if(tableData.FuelEscalatorFlag){
                      <span class="value new-font-size"> {{tableData.FuelTrigger}}%</span>
                    }
                </div>
              <div class="items">
                <span class="key new-font-size">Effective Date: </span>
                <span class="value new-font-size"> {{effectiveDate |date:'dd/MM/yyyy'}}</span>
            </div>
            </div>

        </tr>
   
    </table>
  }
    <!-- <br> -->

    <table style="border: 1.5px solid #000;"  class="rate-table"  *ngIf="tableType=='fixed'" cellspacing="0" mat-table [dataSource]="dbDataSource"> 
        <tr class="accord-area new-font-size">
            @for (i of destinCol; track $index) {
                <ng-container matColumnDef={{i}}>
                @if (i === "Distance") {
                    <th mat-header-cell class="scrollable" style="border-right: 1px solid #000;background-color: #FFCC00; font-size: 10px;"   [attr.colspan]=1 *matHeaderCellDef>
                        <div class="new-font-size" style="text-transform: uppercase;text-align: left;font-weight: 600;">Service</div>
                    </th>
                }
                @else{
                    <th mat-header-cell class="scrollable unsetstyle" style="border-right: 1px solid #000;background-color: #FFCC00;font-size: 10px;"   [attr.colspan]=3 *matHeaderCellDef>
                        <div class="new-font-size" style="text-transform: uppercase;text-align: left;font-weight: 600;">{{i}}</div>
                    </th>
                }
    
                </ng-container>  
                }
                @for (i of displayedCol; track $index) {
                    <ng-container matColumnDef={{i}}>
                        <th mat-header-cell class="scrollable" style="font-weight: 600;background-color: #FFCC00;font-size: 12px;" *matHeaderCellDef [ngClass]="(((i).split('-')[1]) === 'roundtrip' || i==='service')?'headerStyle':'unsetstyle'">
                            @if (i === "service") {
                                <div class="new-font-size" style="text-transform: capitalize;text-align: center;"></div>
                            }
                            @else {
                                <div class="new-font-size" style="text-transform: capitalize;text-align: center;font-size: 12px;">{{(i).split("-")[1]}}</div>
                            }
                        </th>
                        @if (i === "service") {
                            <ng-container *matCellDef="let element; let ind=index">
                                <!-- @if(ind ===0){
                                    <td class="scrollable" mat-cell  rowspan="14" >
                                        <div style="width: 200px; height: 690px;font-size: 12px;" *ngIf="ind ===0" >{{element[i]}}</div>
                                    </td>
                                } -->
                             
                                  <td class="scrollable" mat-cell  >
                                      <div class="new-font-size"   >{{element[i]}}</div>
                                  </td>
                            </ng-container>
                        }
                        @else{
                        <td class="scrollable" mat-cell *matCellDef="let element; let ind=index" [ngClass]="(((i).split('-')[1]) === 'roundtrip' || i==='service')?'boderStyle':'unsetstyle'">
                            <div class="new-font-size">{{formatElementData(element[i])}}</div>
                        </td>
                    }
                    </ng-container>
                    }

        </tr>
        <tr class="new-font-size" mat-header-row *matHeaderRowDef="destinCol"></tr>
        <tr class="new-font-size" mat-header-row *matHeaderRowDef="displayedCol"></tr>
        <tr class="new-font-size" mat-row *matRowDef="let row; columns: displayedCol;"></tr>
    </table>  
<div class="page-break">
    <div class="addition-charge-area" style="justify-content: space-between;">
      @if(fileType === "excel"){
        <table> <tr></tr><tr></tr><tr><td colspan="3">Additional Charge</td></tr></table>
            <table style="margin-bottom: 20px;" cellspacing="0" mat-table [dataSource]="chargesList" >
              <tr class="accord-area">
                @for (i of ["charge","rate"]; track $index) {
                  <ng-container matColumnDef={{i}}>
                    <th mat-header-cell class="scrollable" style="background-color: #FFCC00;border: 1px solid #000;" *matHeaderCellDef>
                      <div style="text-transform: capitalize;font-weight: bold;">{{i}}</div>
                    </th>
                    <td class="scrollable" mat-cell *matCellDef="let element; let ind=index" style="border:1px solid #000">
                      <div>{{element[i]}}</div>
                    </td>
                  </ng-container>
                }
              </tr>
              <tr mat-header-row *matHeaderRowDef='["charge","rate"]'></tr>
              <tr mat-row *matRowDef='let row; columns: ["charge","rate"]'></tr>
        
            </table>

          <div class="maunt-area form-container" style="margin-left: 10px;">
            <table><tr></tr><tr></tr><tr><td colspan="3">Maut</td></tr></table>
            <table style="margin-bottom: 20px;" cellspacing="0" mat-table [dataSource]="mauntList">
              
              <tr class="accord-area">
                @for (i of ["country","rate"]; track $index) {
               
                @if(i === "country"){
                <ng-container matColumnDef={{i}}>
                  <th mat-header-cell class="scrollable key" style="background-color: #FFCC00;" *matHeaderCellDef>Country</th>
                  <td class="scrollable" mat-cell *matCellDef="let element;let ind=Index" style="border:1px solid #000">
                      <span>{{this.findCountryName(element[i])}}</span>
                  </td>
                </ng-container>
                } 
                @else {
                  <ng-container matColumnDef={{i}}>
                    <th mat-header-cell class="scrollable key" style="background-color: #FFCC00;" *matHeaderCellDef>Maut Kms</th>
                    <td class="scrollable" mat-cell *matCellDef="let element; let ind=index" style="border: 1px solid #000;">
                        <div>{{element[i]}}</div>
                    </td>
                  </ng-container>
                  }
                } 
              </tr>
              <tr mat-header-row *matHeaderRowDef='["country","rate"]'></tr>
              <tr mat-row *matRowDef="let row; columns: ['country','rate']"></tr>
        
            </table>
          </div> 
      }
      @else {
        <div class="agreement-area form-container" style="margin-right: 10px;" *ngIf="false">
          <div class="title">Additional Charge</div>
            <table style="margin-bottom: 20px;" cellspacing="0" mat-table [dataSource]="chargesList" >
              <tr class="accord-area  new-font-size">
                @for (i of ["charge","rate"]; track $index) {
                  <ng-container matColumnDef={{i}}>
                    <th mat-header-cell class="scrollable" style="background-color: #FFCC00;border: 1px solid #000;" *matHeaderCellDef>
                      <div style="text-transform: capitalize;font-weight: bold;">{{i}}</div>
                    </th>
                    <td class="scrollable" mat-cell *matCellDef="let element; let ind=index" style="border:1px solid #000">
                      <div>{{element[i]}}</div>
                    </td>
                  </ng-container>
                }
              </tr>
              <tr class=" new-font-size" mat-header-row *matHeaderRowDef='["charge","rate"]'></tr>
              <tr class=" new-font-size" mat-row *matRowDef='let row; columns: ["charge","rate"]'></tr>
        
            </table>
          </div>

          <div class="maunt-area form-container" style="margin-left: 10px;" *ngIf="false">
            <div class="title">Maut</div>
            <table style="margin-bottom: 20px;" cellspacing="0" mat-table [dataSource]="mauntList">
              <tr class="accord-area  new-font-size">
                @for (i of ["country","rate"]; track $index) {
               
                @if(i === "country"){
                <ng-container matColumnDef={{i}}>
                  <th mat-header-cell class="scrollable key" style="background-color: #FFCC00;" *matHeaderCellDef>Country</th>
                  <td class="scrollable" mat-cell *matCellDef="let element;let ind=Index" style="border:1px solid #000">
                      <span>{{this.findCountryName(element[i])}}</span>
                  </td>
                </ng-container>
                } 
                @else {
                  <ng-container matColumnDef={{i}}>
                    <th mat-header-cell class="scrollable key" style="background-color: #FFCC00;" *matHeaderCellDef>Maut Kms</th>
                    <td class="scrollable" mat-cell *matCellDef="let element; let ind=index" style="border: 1px solid #000;">
                        <div>{{formatMautData(element[i])}}</div>
                    </td>
                  </ng-container>
                  }
                } 
              </tr>
              <tr  class="new-font-size" mat-header-row *matHeaderRowDef='["country","rate"]'></tr>
              <tr class="new-font-size" mat-row *matRowDef="let row; columns: ['country','rate']"></tr>
        
            </table>
          </div> 
      }
  </div>

  @if(fileType === 'excel'){
    <table>
      <tr></tr> 
      <tr style="display: inline;">
          <div class="items" style="font-weight: bold;">REMARKS</div>
      </tr> 
      <tr><td colspan="6">{{appService.deResingDoubleQuotess(tableData.Remarks)}}</td></tr>
          <!-- <tr><td colspan="6">- Basis for KM calculation will be latest version of Map&Guide - see also Ford Terms & Conditions / Carrier Specification</td></tr>
          <tr><td colspan="6">- All rates including current Toll/Road Tax but excluding Tolls in following countries to shown seperately on invoices (Euro/km)</td></tr>
          <tr><td colspan="6">- No demurrage will be paid within two hours of the end of the allotted time window. No demurrage will be paid if the carrier has missed the designagted and agreed time window.</td></tr> -->
  </table> 

  }
  @else {
    <table *ngIf="false">
      <br>
      <tr style="display: inline;">
          <div class="items" style="font-weight: bold;">REMARKS</div>
          <div>{{appService.deResingDoubleQuotess(tableData.Remarks)}}</div>
          <!-- <div>- Basis for KM calculation will be latest version of Map&Guide - see also Ford Terms & Conditions / Carrier Specification</div>
          <div>- All rates including current Toll/Road Tax but excluding Tolls in following countries to shown seperately on invoices (Euro/km)</div>
          <div>- No demurrage will be paid within two hours of the end of the allotted time window. No demurrage will be paid if the carrier has missed the designagted and agreed time window.</div> -->
      </tr>     
  </table>

  }
</div>
</div>